module.exports = __webpack_public_path__ + "static/media/repair.85dbd812.svg";